import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';

import { API_ENDPOINTS } from '../constants/api.constants';
import { Account } from '../types/account.model';

@Injectable({
    providedIn: 'root'
})
export class MainService {
    private readonly http = inject(FlamingoHttpService);

    getAccount(): Observable<Account | null> {
        return this.http.get<Account>(API_ENDPOINTS.ACCOUNT.GET_ACCOUNT).pipe(
            catchError(() => {
                console.warn('[MainService] Unable to retrieve account');
                return of(null);
            })
        );
    }

    updateAccount(payload: Partial<Account>): Observable<Account> {
        return this.http.put<Account>(API_ENDPOINTS.ACCOUNT.UPDATE_ACCOUNT, payload);
    }

    login(credentials: { email: string; password: string }): Observable<{ jwt: string } | any> {
        return this.http.post<any>(API_ENDPOINTS.AUTH.LOGIN, credentials).pipe(
            map(response => {
                console.log('[MainService] Login response:', response);
                // Try different possible response formats
                const token = response?.jwt || response?.token || response?.accessToken || response?.access_token;
                if (!token) {
                    console.error('[MainService] No token found in response:', response);
                    throw new Error('Missing authentication token');
                }
                return { jwt: token };
            })
        );
    }

    logout(): Observable<void> {
        return this.http.post<void>(API_ENDPOINTS.AUTH.LOGOUT, {});
    }
}



